module.exports = __webpack_public_path__ + "img/alert-circle.9bbd2937.svg";